// extracted by mini-css-extract-plugin
export default {"header":"NavBar_header__ZqVLa","logo":"NavBar_logo__OGFVx","create":"NavBar_create__0wtpm"};